import { Avatar, Box, Chip, Container, FormControlLabel, Grid, InputLabel, Typography } from "@mui/material"
import { styled } from "@mui/material/styles"
import { CircleIcon } from "components/icons/CircleIcon"

export const backgroundPrimary = ({ theme }) => ({
  backgroundColor: theme.palette.primary["light"],
  color: `${theme.palette.primary["main"]}!important`
})

const userAvatar = ({ theme }) => ({
  fontSize: "1rem",
  marginRight: 24,
  [theme.breakpoints.down("xl")]: {
    marginRight: 14
  }
})

export const StyledPrimaryAvatar = styled(Avatar)(({ theme }) => ({
  backgroundColor: theme.palette.primary[300],
  color: theme.palette.primary[800]
}))
export const StyledPrimaryCircleIcon = styled(CircleIcon)(backgroundPrimary)
export const StyledPrimaryUserAvatar = styled(StyledPrimaryAvatar)(userAvatar)

export const backgroundSuccess = ({ theme }) => ({
  background: `${theme.palette.success["light"]}!important`,
  color: `${theme.palette.success["main"]}!important`
})
export const StyledSuccessAvatar = styled(Avatar)(backgroundSuccess)
export const StyledSuccessUserAvatar = styled(StyledSuccessAvatar)(userAvatar)

const backgroundError = ({ theme }) => ({
  background: `${theme.palette.error["light"]}!important`,
  color: `${theme.palette.error["main"]}!important`
})
export const StyledErrorAvatar = styled(Avatar)(backgroundError)
export const StyledErrorUserAvatar = styled(StyledErrorAvatar)(userAvatar)

const backgroundWarning = ({ theme }) => ({
  background: `${theme.palette.warning["light"]}!important`,
  color: `${theme.palette.warning["main"]}!important`
})
export const StyledWarningAvatar = styled(Avatar)(backgroundWarning)
export const StyledWarningUserAvatar = styled(StyledWarningAvatar)(userAvatar)

const backgroundGrey = ({ theme }) => ({
  background: `${theme.palette.grey[100]}!important`,
  color: `${theme.palette.grey[800]}!important`
})
export const StyledGreyAvatar = styled(Avatar)(backgroundGrey)
export const StyledGreyUserAvatar = styled(StyledGreyAvatar)(userAvatar)
export const StyledGreyGrid = styled(Grid)(backgroundGrey)

export const StyledFormLabel = styled(InputLabel)(({ theme }) => ({
  marginBottom: "5px",
  color: theme.palette.default[900]
}))

const margin0 = {
  margin: 0
}
export const StyledFormControlLabel = styled(FormControlLabel)(margin0)

export const StyledTableContainer = styled(Box)(({ theme, activeBg = true }) => {
  let style = {
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      "& > div": {
        position: "relative",
        "& .MuiTableContainer-root": {
          overflow: "auto"
        }
      }
    }
  }
  if (activeBg) {
    style.background = theme.palette.foreground.inverted
  }

  return style
})

export const StyledTypography = styled(Typography)({
  margin: 0
})
export const StyledChip = styled(Chip)(({ turnedIn }) => {
  if (turnedIn) {
    return backgroundSuccess
  }
  return backgroundPrimary
})

export const StyledHeaderContainer = styled(Container)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center"
})
